import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class ListaPrecioDetalleService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerPrecioCosto(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: lista_precio_detalleInputType) {
            lista_precio_detalle {
              obtenerPrecioCosto(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  empresa_rut
                  sucursal_codigo
                  precio_costo
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.lista_precio_detalle.obtenerPrecioCosto;
            callback({ mensajes, respuesta });
        });
    }
    guardarPrecioCosto(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        mutation ($entidad: lista_precio_detalleInputType) {
          lista_precio_detalle {
            guardarPrecioCosto(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                empresa_rut
                sucursal_codigo
                precio_neto
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.lista_precio_detalle.guardarPrecioCosto;
            callback({ mensajes, respuesta });
        });
    }
}
ListaPrecioDetalleService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ListaPrecioDetalleService_Factory() { return new ListaPrecioDetalleService(i0.ɵɵinject(i1.GraphQLClient)); }, token: ListaPrecioDetalleService, providedIn: "root" });
